import { create } from 'zustand';

/**
 * TDEV-266 Phase 6 — dashboard-local sidebar store (persistence-free).
 *
 * Server-backed persistence runs through `SettingsSync` (see
 * `apps/dashboard/web/src/components/SettingsSync.tsx`). The previous
 * `createSidebarStore({ name: 'dashboard-sidebar' })` factory (which wires
 * zustand `persist` against localStorage) stays UNCHANGED in `@dawn/ui`
 * (Decision #14 LOCK) — only this dashboard-local store rewires to a plain
 * `create()` so the only persistence surface is the `admin_settings` row +
 * the TanStack `EffectiveSettings` query, not localStorage.
 *
 * Public surface ({ isOpen, toggle, setOpen }) MUST stay intact —
 * `toggle` is consumed by `DashboardLayout` and asserted in
 * `sidebar.test.ts` (plan.md:1310, Decision #14 LOCK from advisory #4).
 */
interface SidebarState {
  isOpen: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()((set) => ({
  isOpen: true,
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (isOpen) => set({ isOpen }),
}));
